/* =====================================================================
   StoreGoods — Theme-JavaScript (Vanilla, keine Bibliotheken)
   Header, Scroll-Reveal, Wishlist, Mobile-Drawer, Suche, AJAX-Warenkorb,
   Quick-Add. Alles progressive Enhancement.
   ===================================================================== */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SG = window.SG || {};
  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return euro.format((cents || 0) / 100); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* -------- Header: immer sichtbar, wird nur kompakter -------- */
  function initHeader() {
    var h = $('.site-header'); if (!h) return;
    var f = function () { h.classList.toggle('scrolled', scrollY > 8); };
    addEventListener('scroll', f, { passive: true }); f();
  }

  /* -------- Scroll-Reveal -------- */
  function initReveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: .08 });
    $$('.reveal', root).forEach(function (el) { io.observe(el); });
    $$('.pgrid', root).forEach(function (g) {
      Array.prototype.slice.call(g.children).forEach(function (c, i) {
        c.classList.add('reveal'); c.style.setProperty('--d', Math.min(i * 55, 330) + 'ms'); io.observe(c);
      });
    });
  }

  /* -------- Wishlist (localStorage) -------- */
  var WK = 'sg_wishlist';
  var wget = function () { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } };
  var wset = function (a) { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} };
  function initWishlist(root) {
    var list = wget();
    $$('.wish', root).forEach(function (b) {
      var id = b.getAttribute('data-handle');
      if (id && list.indexOf(id) > -1) { b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.wish'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var id = b.getAttribute('data-handle'); if (!id) return;
    var list = wget(), i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); }
    else { list.push(id); b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); }
    wset(list);
    if (!reduce) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' });
    // Im Wunschlisten-Drawer: entfernten Artikel gleich ausblenden
    if (i > -1 && b.closest('#WishlistItems')) {
      var card = b.closest('.card'); if (card) card.remove();
      if (!wget().length) { var empty = document.getElementById('WishlistEmpty'); if (empty) empty.style.display = ''; }
    }
  });

  /* -------- Mobile-Drawer -------- */
  function initMobileNav() {
    var mnav = $('#MobileNav'), scrim = $('#Scrim');
    var burger = $('#Burger'); if (!burger) return;
    burger.addEventListener('click', function () { mnav.classList.add('on'); scrim.classList.add('on'); document.body.style.overflow = 'hidden'; });
    $$('[data-close-mnav]').forEach(function (b) { b.addEventListener('click', closeMobile); });
  }
  function closeMobile() {
    var mnav = $('#MobileNav'); if (mnav) mnav.classList.remove('on');
    if (!$('.drawer.on')) { var s = $('#Scrim'); if (s) s.classList.remove('on'); document.body.style.overflow = ''; }
  }

  /* -------- Accordion (Echtheit/FAQ/Produkt) -------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.acc__q'); if (!q) return;
    q.parentElement.classList.toggle('open');
    var ex = q.parentElement.classList.contains('open'); q.setAttribute('aria-expanded', ex ? 'true' : 'false');
  });

  /* -------- Suche-Overlay + Predictive Search -------- */
  function initSearch() {
    var ov = $('#SearchOverlay'); if (!ov) return;
    var input = $('#SearchInput', ov), results = $('#SearchResults', ov), t;
    $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', function () { ov.classList.add('on'); document.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 60); }); });
    $$('[data-close-search]', ov).forEach(function (b) { b.addEventListener('click', closeSearch); });
    ov.querySelector('.overlay-search__bd').addEventListener('click', closeSearch);
    function closeSearch() { ov.classList.remove('on'); document.body.style.overflow = ''; }
    window._closeSearch = closeSearch;
    input.addEventListener('input', function () {
      clearTimeout(t); var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { results.innerHTML = '<p style="color:var(--muted)">Keine Treffer für „' + q + '".</p>'; return; }
            results.innerHTML = items.map(function (p) {
              var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
              var priceStr = (p.price != null && p.price !== '') ? money(Math.round(parseFloat(p.price) * 100)) : '';
              return '<a class="sres" href="' + p.url + '"><span class="sres__img">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '') + '</span><span><span class="sres__t">' + p.title + '</span><br><span class="sres__p">' + priceStr + '</span></span></a>';
            }).join('');
          }).catch(function () { results.innerHTML = ''; });
      }, 180);
    });
  }

  /* -------- Warenkorb (AJAX) -------- */
  function refreshCart() {
    return fetch((SG.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function renderCart(cart) {
    var n = $('#CartCount'); if (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; }
    var wrap = $('#CartItems'); if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="drawer__empty">Dein Warenkorb ist noch leer.</div>';
    } else {
      wrap.innerHTML = cart.items.map(function (it) {
        var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
        return '<div class="ci" data-key="' + it.key + '">' +
          '<span class="ci__img">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="">' : '') + '</span>' +
          '<div><div class="ci__t">' + it.product_title + '</div><div class="ci__m">' + opts + '</div>' +
          (it.properties && it.properties.Lieferzeit ? '<div class="ci__pre">' + it.properties.Lieferzeit + '</div>' : '') +
          '<div class="ci__q"><button data-dec aria-label="Weniger">–</button><span>' + it.quantity + '</span><button data-inc aria-label="Mehr">+</button></div></div>' +
          '<div><div class="ci__p">' + money(it.final_line_price) + '</div><button class="ci__rm" data-rm>Entfernen</button></div>' +
          '</div>';
      }).join('');
    }
    var tot = $('#CartTotal'); if (tot) tot.textContent = money(cart.total_price);
    // Free-Shipping
    var fs = $('#Freeship'); if (fs) {
      var thr = SG.freeship || 10000, rem = Math.max(0, thr - cart.total_price), pct = Math.min(100, cart.total_price / thr * 100);
      $('.freeship__bar', fs).style.width = pct + '%';
      fs.classList.toggle('done', rem <= 0);
      $('.freeship__msg', fs).innerHTML = rem <= 0 ? '🎉 <strong>Kostenloser Versand</strong> freigeschaltet.' : 'Noch <strong>' + money(rem) + '</strong> bis zum kostenlosen Versand.';
      fs.style.display = cart.item_count ? '' : 'none';
    }
  }
  function openCart() { var s = $('#Scrim'), d = $('#CartDrawer'); if (!d) return; s.classList.add('on'); d.classList.add('on'); document.body.style.overflow = 'hidden'; }
  function closeCart() { var d = $('#CartDrawer'); if (d) d.classList.remove('on'); if (!$('#MobileNav') || !$('#MobileNav').classList.contains('on')) { var s = $('#Scrim'); if (s) s.classList.remove('on'); document.body.style.overflow = ''; } }
  window._openCart = openCart;

  function addVariant(id, qty) {
    return fetch((SG.routes.cart_add || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); }).then(function () { openCart(); bump(); });
  }
  function changeLine(key, qty) {
    return fetch((SG.routes.cart_change || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function bump() { var n = $('#CartCount'); if (!n || reduce) return; n.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 300, easing: 'ease-out' }); }
  function flyToCart(img, done) {
    var cart = $('[data-open-cart]');
    if (reduce || !img || !cart) { bump(); if (done) done(); return; }
    var s = img.getBoundingClientRect(), c = cart.getBoundingClientRect();
    if (!s.width) { bump(); if (done) done(); return; }
    var clone = img.cloneNode(true); clone.removeAttribute('id');
    clone.style.cssText = 'position:fixed;z-index:2000;left:' + s.left + 'px;top:' + s.top + 'px;width:' + s.width + 'px;height:' + s.height + 'px;border-radius:12px;object-fit:cover;pointer-events:none;box-shadow:0 12px 32px rgba(0,0,0,.28)';
    document.body.appendChild(clone);
    var dx = (c.left + c.width / 2) - (s.left + s.width / 2), dy = (c.top + c.height / 2) - (s.top + s.height / 2);
    var a = clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.55) + 'px,' + (dy * 0.55 - 50) + 'px) scale(.55) rotate(-8deg)', opacity: 1, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1) rotate(-14deg)', opacity: .25 }
    ], { duration: 680, easing: 'cubic-bezier(.5,.02,.5,1)' });
    var fin = function (b) { if (clone._done) return; clone._done = true; if (clone.parentNode) clone.remove(); if (b) bump(); if (done) done(); };
    a.onfinish = function () { fin(true); };
    a.oncancel = function () { fin(false); };
    setTimeout(function () { fin(true); }, 950);
  }
  function atcSuccess(form) {
    var btn = form.querySelector('[name="add"]'); if (!btn) return;
    var span = btn.querySelector('span'), orig = span ? span.textContent : '';
    if (!reduce) btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(.95)' }, { transform: 'scale(1)' }], { duration: 240, easing: 'ease-out' });
    btn.classList.add('is-added'); if (span) span.textContent = '✓ Hinzugefügt';
    setTimeout(function () { btn.classList.remove('is-added'); if (span) span.textContent = orig; }, 1500);
  }

  // Delegated cart interactions
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); refreshCart(); }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); }
    var ci = e.target.closest('.ci');
    if (ci) {
      var key = ci.getAttribute('data-key'), q = parseInt($('.ci__q span', ci).textContent, 10);
      if (e.target.closest('[data-inc]')) changeLine(key, q + 1);
      else if (e.target.closest('[data-dec]')) changeLine(key, Math.max(0, q - 1));
      else if (e.target.closest('[data-rm]')) changeLine(key, 0);
    }
    // Quick-Add: direkt (1 Variante) oder Größen-Popover (mehrere)
    var qa = e.target.closest('.quickadd');
    if (qa) {
      e.preventDefault();
      var direct = qa.getAttribute('data-variant');
      if (direct) { addVariant(direct, 1); }
      else { var card = qa.closest('.card'); $$('.card.picking').forEach(function (c) { if (c !== card) c.classList.remove('picking'); }); card.classList.add('picking'); }
    }
    var sb = e.target.closest('.sizes__grid button');
    if (sb && !sb.disabled) { e.preventDefault(); var vid = sb.getAttribute('data-variant'); if (vid) addVariant(vid, 1); sb.closest('.card').classList.remove('picking'); }
    if (!e.target.closest('.sizes') && !e.target.closest('.quickadd')) $$('.card.picking').forEach(function (c) { c.classList.remove('picking'); });
  });

  // Produktseite / normale add-to-cart Formulare -> AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]'); if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var flyImg = document.querySelector('.pdp__main img');
    atcSuccess(form);
    fetch((SG.routes.cart_add || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function () { return refreshCart(); }).then(function () { flyToCart(flyImg, function () { openCart(); }); })
      .catch(function () { form.submit(); });
  });

  addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMobile(); if (window._closeSearch) window._closeSearch(); } });

  /* -------- Kollektions-Filter (Facets) -------- */
  function initFacets() {
    var form = $('#FacetForm'); if (!form) return;
    var grid = $('#ProductGrid');
    var sortSel = $('[data-sort]');
    var filters = $('#CollFilters'), fscrim = $('#FilterScrim'), t;

    // Mobile-Filter-Drawer
    $$('[data-open-filters]').forEach(function (b) { b.addEventListener('click', function () { filters.classList.add('on'); fscrim.classList.add('on'); document.body.style.overflow = 'hidden'; }); });
    function closeFilters() { filters.classList.remove('on'); fscrim.classList.remove('on'); document.body.style.overflow = ''; }
    $$('[data-close-filters]').forEach(function (b) { b.addEventListener('click', closeFilters); });
    if (fscrim) fscrim.addEventListener('click', closeFilters);

    function update() {
      if (sortSel) { var h = form.querySelector('[name="sort_by"]'); if (h) h.value = sortSel.value; }
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) params.append(k, v); });
      var url = location.pathname + (params.toString() ? '?' + params.toString() : '');
      if (grid) grid.classList.add('is-loading');
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = doc.getElementById('ProductGrid'); if (ng && grid) grid.innerHTML = ng.innerHTML;
          var nc = doc.getElementById('CollCount'), cc = $('#CollCount'); if (nc && cc) cc.textContent = nc.textContent;
          if (grid) grid.classList.remove('is-loading');
          history.pushState({}, '', url);
          initReveal(grid); initWishlist(grid);
        }).catch(function () { location.href = url; });
    }

    form.addEventListener('change', function (e) { if (e.target.type === 'checkbox') update(); });
    form.addEventListener('input', function (e) { if (e.target.type === 'number') { clearTimeout(t); t = setTimeout(update, 500); } });
    if (sortSel) sortSel.addEventListener('change', update);
  }

  /* -------- Produkt-Slider (horizontale Reihen) -------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (row) {
      var sec = row.closest('section');
      var prev = sec && sec.querySelector('[data-carousel-prev]');
      var next = sec && sec.querySelector('[data-carousel-next]');
      var amount = function () { return Math.max(row.clientWidth * 0.85, 300); };
      var busy = false;
      function glide(dir) {
        var cards = row.children;
        if (!cards.length) return;
        var step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth;
        if (step < 1) step = cards[0].offsetWidth || 260;
        var perView = Math.max(1, Math.round(amount() / step));
        var maxL = row.scrollWidth - row.clientWidth;
        var curIdx = Math.round(row.scrollLeft / step);
        var targetIdx = Math.max(0, Math.min(curIdx + dir * perView, cards.length - 1));
        var startL = row.scrollLeft;
        // offsetLeft bezieht sich auf die Seite (Slider ist nicht positioniert) -> relativ zur ersten Karte rechnen
        var targetL = Math.max(0, Math.min(cards[targetIdx].offsetLeft - cards[0].offsetLeft, maxL));
        if (Math.abs(targetL - startL) < 1) return;
        if (reduce) { row.scrollLeft = targetL; return; }
        // Snap waehrend der Animation aus, damit die Zwischen-Frames nicht eingerastet werden.
        var t0 = null, dur = 460;
        busy = true;
        row.style.scrollSnapType = 'none';
        function stepFn(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          row.scrollLeft = startL + (targetL - startL) * e;
          if (p < 1) requestAnimationFrame(stepFn);
          else { row.style.scrollSnapType = ''; busy = false; }
        }
        requestAnimationFrame(stepFn);
      }
      if (prev) prev.addEventListener('click', function () { if (!busy) glide(-1); });
      if (next) next.addEventListener('click', function () { if (!busy) glide(1); });
      function upd() { var max = row.scrollWidth - row.clientWidth - 2; if (prev) prev.disabled = row.scrollLeft <= 2; if (next) next.disabled = row.scrollLeft >= max; }
      row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  /* -------- Hero: sanftes Zurücktreten beim Scrollen (dezent, kein Parallax-Jacking) -------- */
  function initHeroScroll() {
    if (reduce) return;
    var hero = $('.hero'); if (!hero) return;
    var img = $('.hero__img', hero);
    var tags = $$('.hero__tag', hero);
    if (!img) return;
    function upd() {
      var h = hero.offsetHeight || 1;
      var p = Math.min(Math.max(scrollY / h, 0), 1);
      var op = String(1 - p * 0.85);
      img.style.transform = 'translateY(' + (p * -34) + 'px) scale(' + (1 - p * 0.10) + ')';
      img.style.opacity = op;
      tags.forEach(function (t) { t.style.opacity = String(1 - p * 1.6); });
    }
    addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  /* -------- Geteilt: Produktkarten aus Handles rendern -------- */
  var esc = function (s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20s-7.5-4.6-9.6-9.2C1 7.5 2.6 4.5 5.7 4.5c1.9 0 3.3 1.1 4.3 2.6 1-1.5 2.4-2.6 4.3-2.6 3.1 0 4.7 3 3.3 6.3C19.5 15.4 12 20 12 20z"/></svg>';
  function cardMarkup(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    var imgTag = img ? '<img class="only" loading="lazy" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + esc(p.title) + '">' : '';
    var price = (p.price_varies ? 'ab ' : '') + money(p.price);
    var vendor = p.vendor ? '<div class="card__vendor">' + esc(p.vendor) + '</div>' : '';
    return '<div class="card"><div class="card__media"><a href="' + p.url + '">' + imgTag + '</a>' +
      '<button class="wish" type="button" data-handle="' + p.handle + '" aria-label="Merken">' + HEART + '</button></div>' +
      '<div class="card__info">' + vendor + '<div class="card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></div>' +
      '<div class="card__price">' + price + '</div></div></div>';
  }
  function renderProducts(handles, container, cb) {
    if (!container) return;
    if (!handles.length) { container.innerHTML = ''; if (cb) cb(0); return; }
    Promise.all(handles.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (prods) {
        var valid = prods.filter(Boolean);
        container.innerHTML = valid.map(cardMarkup).join('');
        initWishlist(container);
        if (cb) cb(valid.length);
      });
  }

  /* -------- Zuletzt angesehen -------- */
  var RK = 'sg_recent';
  var getRecent = function () { try { return JSON.parse(localStorage.getItem(RK) || '[]'); } catch (e) { return []; } };
  var curHandle = function () { return (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]; };
  function trackRecent() {
    var h = curHandle(); if (!h) return;
    var list = getRecent().filter(function (x) { return x !== h; });
    list.unshift(h); list = list.slice(0, 12);
    try { localStorage.setItem(RK, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecent() {
    var c = $('#RecentGrid'); if (!c) return;
    var cur = curHandle();
    var list = getRecent().filter(function (h) { return h !== cur; }).slice(0, 6);
    var sec = $('#RecentlyViewed');
    if (!list.length) { if (sec) sec.style.display = 'none'; return; }
    renderProducts(list, c, function (n) { if (sec) sec.style.display = n > 0 ? '' : 'none'; });
  }

  /* -------- Wunschlisten-Drawer -------- */
  function openWishlist() {
    var d = $('#WishlistDrawer'), s = $('#Scrim'); if (!d) return;
    s.classList.add('on'); d.classList.add('on'); document.body.style.overflow = 'hidden';
    var c = $('#WishlistItems'), empty = $('#WishlistEmpty'), list = wget();
    if (!list.length) { c.innerHTML = ''; if (empty) empty.style.display = ''; return; }
    if (empty) empty.style.display = 'none';
    renderProducts(list, c);
  }
  function closeWishlist() { var d = $('#WishlistDrawer'); if (d) d.classList.remove('on'); if (!$('.drawer.on') && !($('#MobileNav') && $('#MobileNav').classList.contains('on'))) { var s = $('#Scrim'); if (s) s.classList.remove('on'); document.body.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-wishlist]')) { e.preventDefault(); openWishlist(); }
    if (e.target.closest('[data-close-wishlist]')) { e.preventDefault(); closeWishlist(); }
  });

  /* -------- Boot -------- */
  function boot() {
    initHeader(); initReveal(document); initWishlist(document); initMobileNav(); initSearch(); initFacets(); initCarousels(document); initHeroScroll();
    trackRecent(); renderRecent(); refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initWishlist(e.target); initCarousels(e.target); });
})();
